import { EDatasetsNames } from 'Common/consts';
export const isDatasetWithAncestry = (datasetName) => [
    EDatasetsNames.INTERNAL_500K,
    EDatasetsNames.PUBLIC_500K,
].includes(datasetName);
